import { render } from "./QuizResultCard.vue?vue&type=template&id=207e831c"
import script from "./QuizResultCard.vue?vue&type=script&lang=js"
export * from "./QuizResultCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__